import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import DataBox from '../../../general/data/DataBox';
import InfoRow from '../../../general/inputs/InfoRow';
import TollIcon from '@mui/icons-material/Toll';
import Button from '../../../general/inputs/Button';
import { setIsUpdateSeatsPopupOpened } from '../../../../redux/features/general/navigation';

interface Props { 

}; 

const Seats: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const group = useAppSelector(state => state.billing.group); 

    const handleSeatsUpdate = () => { 
        dispatch(setIsUpdateSeatsPopupOpened(true)); 
    }; 

    return (
        <Box sx={{ width: '100%', maxWidth: '600px' }}>
            <DataBox 
                title={String(t('subscription'))}
            >
                <InfoRow 
                    icon={<TollIcon sx={{ color: colors?.main }} />}
                    title='seats'
                    description={group?.seats}
                    descriptionStyle={{ fontWeight: 'bold' }}
                    isDisabled
                />
                <InfoRow 
                    title='updateSeats'
                    titleStyle={{ marginLeft: 0 }}
                    description={
                        <Button 
                            title='upgrade'
                            triggerFunction={handleSeatsUpdate}
                        />
                    }
                    isDisabled
                />
            </DataBox>
        </Box>
    );
};

export default Seats;